module.exports = __webpack_public_path__ + "static/img/IMG_20240610_124557.d45b97bc.jpg";